export default {
  data() {
    return {};
  },
  methods: {
    getCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    startRecognitionWork(TmpSecretId, TmpSecretKey, Token, appId, stream) {
      const options = {
        secretKey: TmpSecretKey,
        secretId: TmpSecretId,
        token: Token,
        appId: appId,
        // 实时识别接口参数
        engine_model_type: "16k_zh", // 引擎
        voice_format: 1,
        // 以下为非必填参数，可跟据业务自行修改
        hotword_id: "08003a00000000000000000000000000",
        needvad: 1,
        filter_dirty: 1,
        filter_modal: 1,
        filter_punc: 1,
        convert_num_mode: 1,
        word_info: 2,
        audioTrack: stream.getAudioTrack(),
      };
      const localStreamAsr = new ASR(options);
      // 开始语音识别调用
      localStreamAsr.start();
      // 开始识别
      localStreamAsr.OnRecognitionStart = (res) => {
        console.log("本地流：开始识别", res);
      };
      // 一句话开始
      localStreamAsr.OnSentenceBegin = (res) => {
        console.log("本地流：一句话开始", res);
      };
      // 识别变化时
      localStreamAsr.OnRecognitionResultChange = (res) => {
        console.log("本地流：识别变化时", res);
      };
      // 一句话结束
      localStreamAsr.OnSentenceEnd = (res) => {
        const time = this.getCurrentTime();
        const { voice_id, voice_text_str } = res;
        const data = {
          id: voice_id,
          time: time,
          text: voice_text_str,
          speaker: this.allUsers.find(user => {
            return user.id === stream.getUserId();
          })?.name || "未知用户"
        };
        this.recognitionText.push(data);
        console.log("本地流：一句话结束", res);
      };
      // 识别有结果时
      localStreamAsr.OnChange = (res) => {
        console.log("本地流：识别中", res);
      };
      // 识别结束
      localStreamAsr.OnRecognitionComplete = (res) => {
        console.log("本地流：识别结束", res);
      };
      // 识别错误
      localStreamAsr.OnError = (res) => {
        console.log("本地流：识别失败", res);
        const time = this.getCurrentTime();
        const data = {
          id: -1,
          time: time,
          text: "本地流：识别失败 " + res,
          speaker: ""
        };
        this.recognitionText.push(data);
        // 关闭识别时
        // localStreamAsr.stop();
      };
    }
  }
};
